import React from "react";
import Select from "react-select";

const customStyles = (hasError) => {
  return {
    control: (provided, state) => ({
      ...provided,
      background: "#fbfbfb",
      minHeight: "30px",
      height: "30px",
      borderRadius: "3px",
      boxShadow: state.isFocused ? null : null,
      borderColor: hasError ? "#a94442" : "#cecece",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      opacity: 0.8,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "30px",
      padding: "0 6px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "30px",
    }),
  };
};

class CustomSelect extends React.Component {
  render() {
    return (
      <Select
        {...this.props}
        getOptionLabel={(option) => option[this.props.labelKey]}
        getOptionValue={(option) => option[this.props.valueKey]}
        styles={customStyles(this.props.hasError)}
      />
    );
  }
}

export default CustomSelect;



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Form/SelectOption/CustomSelect.js